import { KYMW1407Model } from '../kymw1407.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { RegistUseImageModel } from '../../kymw1400/vo/regist-use-image.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用画像を登録する。
 *
 * @export
 * @class RegistUseImageService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistUseImageService extends PlessJsonResponderSub<any> {

  private model: KYMW1407Model = null;
  private vo: RegistUseImageModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistUseImageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        KomaId: this.vo.komaId,
        ImageId: this.vo.imageId,
        Pcode: PlessViewUtilsSub.nullToBlank(this.vo.pcode),
        ShowSeq: this.vo.showSeq
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {RegistUseImageModel} vo
   * @memberof RegistUseImageService
   */
  execute(model: KYMW1407Model, vo: RegistUseImageModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14registUseImage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistUseImageService
   */
  success(data: any) {
    // 親画面を更新する
    this.model.refreshKYMW1400();
  }
}
